import { useState, useEffect } from "react";
import Offer from "../../models/Offer";
import OffersService from "../../services/crud/OfferService";
import { DatePicker, Form, FormInstance, Input, Spin, Tooltip } from "antd";
import { LoadingOutlined, QuestionCircleFilled } from "@ant-design/icons";
import { EntitySelector } from "./selects/EntitySelector";
import moment from "moment";
import { LangKeyList } from "../../models/LangKey";
import { LocalizedField } from "./inputs/LocalizedField";

export const OfferFormGenericForm = (props) => {
  const form: FormInstance = props.form;
  const id = props.id;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    form.resetFields();
    if (id) {
      setLoading(true);
      OffersService.getOffer(id).then((data) => {
        setLoading(false);

        data.startDate = data.startDate ? (moment(data.startDate) as any) : null;
        data.endDate = data.endDate ? (moment(data.endDate) as any) : null;
        data.voucherName = data.voucherName ? JSON.parse(data.voucherName) : null;

        form.setFieldsValue(data);
      });
    }

    // Load data
  }, [form, id]);

  if (loading) {
    return <></>;
  }

  const content = (
    <Form<Offer> form={form}>
      <Form.Item noStyle name="id">
        <Input type="hidden" />
      </Form.Item>

      <Form.Item label="Name" name="name" required>
        <Input maxLength={32} />
      </Form.Item>
      <Tooltip title="This is a name of the offer that currently does not show up in the app">
        <QuestionCircleFilled />
      </Tooltip>

      <Form.Item label="Offer start date" name="startDate">
        <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
      </Form.Item>
      <Tooltip title="If set, the offer is not visible in the app until this date">
        <QuestionCircleFilled />
      </Tooltip>

      <Form.Item label="Offer end date" name="endDate">
        <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
      </Form.Item>
      <Tooltip title="If set, the offer is not visible in the app after this date">
        <QuestionCircleFilled />
      </Tooltip>

      <LocalizedField
        supportedLanguages={LangKeyList}
        name="voucherName"
        inputType="input"
        label="Voucher Name"
        placeholder=" "
        minLabelWidth={20}
      />
      <Tooltip title="This will show up in the app both in the amount dropdown and as in-app text of the purchased voucher.">
        <QuestionCircleFilled />
      </Tooltip>

      <Form.Item label="Voucher Code" name="voucherCode" required>
        <Input.Password visibilityToggle />
      </Form.Item>
      <Tooltip title="The voucher code that will be visible to the user after they purchased the offer.">
        <QuestionCircleFilled />
      </Tooltip>

      <Form.Item label="Voucher TSP" name="tspKey" required>
        <EntitySelector.Tsps valueIndex="tspKey" />
      </Form.Item>

      <Form.Item label="Granted to accounts" name="accountIds" required>
        <EntitySelector.Accounts mode="multiple" accountTypes={['company', 'real_estate']} />
      </Form.Item>
      <Tooltip title="Users that belong to the listed accounts will be granted access to the offer">
        <QuestionCircleFilled />
      </Tooltip>
    </Form>
  );

  if (loading) {
    return (
      <Spin size="large" tip="Loading" indicator={<LoadingOutlined />}>
        {content}
      </Spin>
    );
  }
  return content;
};
